import { render, staticRenderFns } from "./RiskScenarios.vue?vue&type=template&id=15dc92a3&"
import script from "./RiskScenarios.vue?vue&type=script&lang=js&"
export * from "./RiskScenarios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports